import axios from "../../../../api/axios";

import { SkillsResponse } from "../types/skills.types";

export const getUserSkills = async (userId: string): Promise<SkillsResponse> => {
  try {
    const response = await axios.get<SkillsResponse>(`users/${userId}/skills/v1`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch user skills: ${(err as Error).message}`);
  }
};
